import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import {
  defaultOpfB2bCheckoutOccEndpointsConfig,
  OPF_B2B_CHECKOUT_FEATURE,
  OpfB2bCheckoutRootModule,
} from '@spartacus/opf/b2b-checkout/root';
import { OPF_BASE_FEATURE, OpfBaseRootModule, OpfConfig } from '@spartacus/opf/base/root';
import {
  opfCheckoutTranslationChunksConfig,
  opfCheckoutTranslationsDe,
  opfCheckoutTranslationsEn,
  opfCheckoutTranslationsZh,
} from '@spartacus/opf/checkout/assets';
import { OPF_CHECKOUT_FEATURE, OpfCheckoutRootModule } from '@spartacus/opf/checkout/root';
import {
  OPF_GLOBAL_FUNCTIONS_FEATURE,
  OpfGlobalFunctionsRootModule,
} from '@spartacus/opf/global-functions/root';
import {
  opfPaymentTranslationChunksConfig,
  opfPaymentTranslationsDe,
  opfPaymentTranslationsEn,
  opfPaymentTranslationsZh,
} from '@spartacus/opf/payment/assets';
import { OPF_PAYMENT_FEATURE, OpfPaymentRootModule } from '@spartacus/opf/payment/root';

@NgModule({
  declarations: [],
  imports: [
    OpfCheckoutRootModule,
    OpfB2bCheckoutRootModule,
    OpfBaseRootModule,
    OpfPaymentRootModule,
    OpfGlobalFunctionsRootModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [OPF_CHECKOUT_FEATURE]: {
          module: () => import('@spartacus/opf/checkout').then((m) => m.OpfCheckoutModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: opfCheckoutTranslationsEn, de: opfCheckoutTranslationsDe, zh: opfCheckoutTranslationsZh },
        chunks: opfCheckoutTranslationChunksConfig,
      },
    }),
    provideConfig(<OpfConfig>{
      // TODO:Spartacus - The type of property 'opf: { opfBaseUrl?: string; commerceCloudPublicKey?: string; paymentOption?: { paymentInfoMessagesMap?: Record<number, string>; enableInfoMessage?: boolean; }; localPspResources?: Record<number, { jsFiles: string[]; cssFiles: string[]; }>; }' changed to: 'opf: { opfBaseUrl?: string; commerceCloudPublicKey?: string; paymentOption?: { paymentInfoMessagesMap?: Record<number, string>; enableInfoMessage?: boolean; iframeSandboxMap?: Record<number, string>; }; localPspResources?: Record<number, { jsFiles: string[]; cssFiles: string[]; }>; }'
      opf: {
        opfBaseUrl:
          'https://ci5wi-geagroupa1-s4.opf.commerce.eu.context.cloud.sap/commerce-cloud-adapter/storefront',
        commerceCloudPublicKey: '0BrZJ3UIz1XvW2S3wETGf4pT2bT6EmnsUyQpt0555CQ=', //use for jsapps
        //commerceCloudPublicKey: "KOxa02UCNMf0fGNJvJGPqiKLe18xjVswQH6vbK/hiYg=", //use for local tests
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [OPF_B2B_CHECKOUT_FEATURE]: {
          module: () => import('@spartacus/opf/b2b-checkout').then((m) => m.OpfB2bCheckoutModule),
        },
      },
    }),
    provideConfig(defaultOpfB2bCheckoutOccEndpointsConfig),
    provideConfig(<CmsConfig>{
      featureModules: {
        [OPF_BASE_FEATURE]: {
          module: () => import('@spartacus/opf/base').then((m) => m.OpfBaseModule),
        },
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [OPF_PAYMENT_FEATURE]: {
          module: () => import('@spartacus/opf/payment').then((m) => m.OpfPaymentModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: opfPaymentTranslationsEn, de: opfPaymentTranslationsDe, zh: opfPaymentTranslationsZh },
        chunks: opfPaymentTranslationChunksConfig,
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [OPF_GLOBAL_FUNCTIONS_FEATURE]: {
          module: () =>
            import('@spartacus/opf/global-functions').then((m) => m.OpfGlobalFunctionsModule),
        },
      },
    }),
  ],
})
export class OpfFeatureModule {}
